import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendForm,
  initState,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors
} from '../../../../common/reducers/forms/changePasswordForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

function* changePassword(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserService.changePassword,
      formBody
    );
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      } else if (response.status === 200) {
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: response.data.message
          })
        );
        yield put(initState(reducerName));
      }
      yield put(requestFinished(reducerName, response.status));
    }
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [takeEvery(sendForm(reducerName).type, changePassword, reducerName)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/changePasswordFormSaga.js